import type { TTemplateAudienceProblem } from 'types/template/templateAudience.types';

const COPY_AUDIENCE_MISMATCH = 'template_copy_audience_mismatch';

export function getCopyAudienceProblems(rejected: unknown): TTemplateAudienceProblem[] | undefined {
  if (!rejected || typeof rejected !== 'object') return undefined;
  if ('error' in rejected) return getCopyAudienceProblems(rejected.error);
  if (!('data' in rejected)) return undefined;

  const { data } = rejected;
  if (!data || typeof data !== 'object' || !('code' in data) || data.code !== COPY_AUDIENCE_MISMATCH) return undefined;
  return 'problems' in data && Array.isArray(data.problems) ? (data.problems as TTemplateAudienceProblem[]) : undefined;
}
